import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress non-critical postMessage errors from third-party scripts (Google OAuth, analytics)
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorString = args[0]?.toString?.() || '';
  if (errorString.includes('postMessage') || 
      errorString.includes('cloned') ||
      errorString.includes('Request object could not be cloned')) {
    return; // Suppress postMessage errors
  }
  originalConsoleError.apply(console, args);
};

// Suppress unhandled promise rejections from Google OAuth postMessage issues
window.addEventListener('unhandledrejection', (event) => {
  const errorString = event.reason?.toString?.() || event.reason?.message || '';
  if (errorString.includes('postMessage') || 
      errorString.includes('cloned') ||
      errorString.includes('Request object could not be cloned')) {
    event.preventDefault(); // Prevent the error from propagating
    return;
  }
});

// Suppress error events from Google OAuth
window.addEventListener('error', (event) => {
  const errorString = event.message || event.error?.message || '';
  if (errorString.includes('postMessage') || 
      errorString.includes('cloned') ||
      errorString.includes('Request object could not be cloned')) {
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
